import { render, staticRenderFns } from "./PresTablePersons.vue?vue&type=template&id=2a4589d6"
import script from "./PresTablePersons.vue?vue&type=script&lang=js"
export * from "./PresTablePersons.vue?vue&type=script&lang=js"
import style0 from "./PresTablePersons.vue?vue&type=style&index=0&id=2a4589d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports